import { Club, ClubPlayer } from "@mixitone/models";
import { AuthController } from "controllers/AuthController";
import { PortalController } from "controllers/PortalController";

interface State {
  clubId: string;
  club: Club;
  clubPlayer: ClubPlayer;
  loading: boolean;
}

interface Props {
  params: { clubId: string };
}

export class ClubController extends PortalController<State, Props> {
  get initialState(): State {
    return {
      clubId: "",
      club: new Club({}),
      clubPlayer: new ClubPlayer({}),
      loading: true,
    };
  }

  async initialize(props: Props) {
    this.state.clubId = props.params.clubId;
    const clubPlayers = this.get(AuthController).state.clubPlayers;
    const clubPlayer = clubPlayers.find((cp) => cp.club_id === this.state.clubId);

    if (!clubPlayer) {
      this.navigate("/in/home");
      return;
    }

    this.state.clubPlayer = clubPlayer;
    this.state.club = clubPlayer.club;
    this.state.loading = false;
  }
}
